var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuLayout',{on:{"back":_vm.back},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.isReady)?_c('router-view'):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }